<template>
  <div class="drawer-stack">
    <!-- Key on identity (component name + id), NOT on all args. Tab/subtab/
         subsubtab are view state, not identity — keying on them would
         remount the LayerHost (and its expensive content component) on
         every tab click, causing a "drawer reload" UX regression. Vue
         reactivity inside the content component is responsible for picking
         up the tab/subtab prop changes via watchers. -->
    <layer-host
      v-for="(entry, idx) in stack"
      :key="entry.name + ':' + entry.args.id"
      :layer-depth="idx + 1"
      :force-visible="true"
      :parent-location="parentLocationFor(idx)"
      :aria-label="ariaLabelFor(entry)">
      <component :is="componentFor(entry)" v-bind="propsFor(entry)" />
    </layer-host>
  </div>
</template>

<script>
import LayerHost from '@/components/atoms/layers/LayerHost'
import { parseDrawerPath, serialiseDrawerStack } from '@/lib/drawerParser'
import { drawerRegistry, isKnownDrawer } from '@/lib/drawerRegistry'

export default {
  name: 'drawer-stack',

  components: {
    LayerHost
  },

  props: {
    // The L0 base path this DrawerStack is mounted on (e.g. '/sites', '/utility').
    basePath: {
      type: String,
      required: true
    }
  },

  computed: {
    // Reactive on $route.path. Parses the drawer tail after basePath.
    stack () {
      var path = this.$route.path
      var tail = path.slice(this.basePath.length)
      // Remove leading slash before parsing
      if (tail.startsWith('/')) tail = tail.slice(1)
      return parseDrawerPath(tail)
    }
  },

  methods: {
    parentLocationFor (idx) {
      if (idx === 0) {
        return { path: this.basePath }
      }
      var parentStack = this.stack.slice(0, idx)
      var tail = serialiseDrawerStack(parentStack)
      return { path: tail ? this.basePath + '/' + tail : this.basePath }
    },

    componentFor (entry) {
      if (!isKnownDrawer(entry.name)) return null
      return drawerRegistry[entry.name].component
    },

    propsFor (entry) {
      if (!isKnownDrawer(entry.name)) return {}
      return drawerRegistry[entry.name].propsFor(entry.args)
    },

    ariaLabelFor (entry) {
      if (!isKnownDrawer(entry.name)) return 'Drawer'
      // Capitalise for screen readers: 'site' → 'Site drawer'
      var label = entry.name.charAt(0).toUpperCase() + entry.name.slice(1)
      return label + ' drawer'
    }
  }
}
</script>
